(function() {
  document.addEventListener("DOMContentLoaded", function() {
    const slidersContainer = document.querySelectorAll('.carousel-collections');
    slidersContainer.forEach((container) => {
      const slider = container.querySelector('.carousel-collections-swiper');
      const swiperInstance = new Swiper(slider, {
        slidesPerView: 2.5,
        spaceBetween: 10,
        pagination: {
          el: container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector(".swiper-button-next"),
          prevEl: container.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 4.5,
            spaceBetween: 10,
            pagination: false,
            slidesPerGroup: 1,
          },
        },
        on: {
          slideChange: function() {
            const activeIndex = swiperInstance.activeIndex;
            const bullets = container.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((bullet, index) => {
              if (index === activeIndex) {
                bullet.classList.add('swiper-pagination-bullet-active');
              } else {
                bullet.classList.remove('swiper-pagination-bullet-active');
              }
            });
          }
        }
      });
    });
  });
})();
